<template>
  <sidenav-right
    :show="isLog"
    :footer-dialog="true"
    :use-save="false"
    :title="$t('webhook.wb_log')"
    @close="closeLog"
  >
    <template v-slot:content>
      <div class="mx-12">
        <el-input
          v-model="searchLog"
          placeholder="Cari"
          class="w-100 m-2"
          @change="searchLogData"
        >
          <template #prefix>
            <el-icon class="el-input__icon">
              <search />
            </el-icon>
          </template>
        </el-input>
      </div>
      <div v-if="!loading">
        <div v-if="!isEmptyLog">
          <el-scrollbar height="80vh" class="mt-14">
            <div v-infinite-scroll="load" :infinite-scroll-disabled="disabled">
              <el-row v-for="item in logs" :key="item.id" class="mx-14 my-12">
                <el-col :span="18">
                  <div class="font-14 font-w-semi-bold color-dark">
                    {{ item.url }}
                  </div>
                  <div class="font-12 color-gray-dark">
                    {{ item.created_time }} WIB
                  </div>
                </el-col>
                <el-col :span="3">
                  <el-button
                    v-if="item.method === 'POST'"
                    plain
                    size="small"
                    class="mt-16"
                    style="color: #178217; border: 1px solid #178217;"
                  >
                    {{ item.method }}
                  </el-button>
                  <el-button
                    v-else
                    plain
                    size="small"
                    class="mt-16"
                    style="color: #0078CE; border: 1px solid #0078CE;"
                  >
                    {{ item.method }}
                  </el-button>
                </el-col>
                <el-col :span="3" class="text-center">
                  <el-icon :size="14" class="mt-20" @click="handleDetail(item)">
                    <arrow-right-bold />
                  </el-icon>
                </el-col>
              </el-row>
            </div>
            <div
              v-if="loadingLog"
              class="flex-container justify-center align-center color-gray-dark"
            >
              <el-icon :size="18">
                <Loading />
              </el-icon>
              <span class="ml-6 font-14">Loading..</span>
            </div>
          </el-scrollbar>
        </div>
        <div v-else>
          <el-row justify="center" class="mx-14">
            <img src="@/assets/icons/bx-empty-webhook.png" height="180" class="mt-32" />
          </el-row>
          <el-row justify="center">
            <div class="font-18 font-w-semi-bold mt-12">
              {{ $t('webhook.no_data') }}
            </div>
          </el-row>
        </div>
      </div>
      <div v-else class="my-24 mx-12">
        <el-skeleton :rows="14" animated />
      </div>
    </template>
  </sidenav-right>
  <webhook-detail
    v-model="dialogDetail"
    :detail="detail"
  />
</template>

<script setup>
import { webhookLog } from '@/api/endpoints/catalog/authOlsera.js'
import { defineProps, defineEmits, onMounted, computed, ref, reactive } from 'vue'
import { Search, ArrowRightBold, Loading } from '@element-plus/icons-vue'
import SidenavRight from '@/components/layout/SidenavRight.vue'
import webhookDetail from './_webhookDetail.vue'

const props = defineProps({
  appId: {
    type: String,
    default: '0',
    required: false
  },
  isLog: {
    required: false
  }
})

const emit = defineEmits(['update:isLog', 'closeLog'])

const loading = ref(false)
const searchLog = ref(null)
const logs = ref([])
const dialogDetail = ref(false)
const detail = ref(null)
const loadingLog = ref(false)
const total = ref(0)
const params = reactive({
  page: 1,
  per_page: 9,
  sort_column: 'id',
  sort_type: 'desc'
})
const noMore = computed(() => logs.value.length >= total.value)
const disabled = computed(() => loadingLog.value || noMore.value)
const isEmptyLog = computed(() => {
  if (logs.value.length <= 0) {
    return true
  }
  return false
})

onMounted(() => {
  getLog()
})

const getLog = () => {
  loading.value = true
  webhookLog(props.appId, params).then(ress => {
    logs.value = ress.data.data
    total.value = ress.data.meta.total
    loading.value = false
  }).catch(err => {
    console.log(err)
    loading.value = false
  })
}
const closeLog = () => {
  emit('closeLog')
}
const searchLogData = () => {
  params.page = 1
  params.search = searchLog.value
  getLog()
}
const load = () => {
  loadingLog.value = true
  setTimeout(() => {
    params.page++
    webhookLog(props.appId, params).then(res => {
      loadingLog.value = false
      res.data.data.forEach(item => logs.value.push(item))
    }).catch(err => {
      console.log(err)
    })
  }, 1000)
}
const handleDetail = (params) => {
  dialogDetail.value = true
  const data = [
    {
      title: 'URL',
      value: params.url
    },
    {
      title: 'Date',
      value: '20 September 2022, 13:00 WIB'
    },
    {
      title: 'Method',
      value: params.method
    },
    {
      title: 'Status Code',
      value: params.status_code
    },
    {
      title: 'Request',
      value: params.request
    },
    {
      title: 'Request Header',
      value: params.request_header
    },
    {
      title: 'Response',
      value: params.response
    }
  ]
  detail.value = data
}
</script>
